<div
  class="card__wrapper"
  [ngClass]="{'not-generated': !box.generated}"
  [title]="!box.generated  && box.number_of_cards !== 0 ? 'Бокс генерируется': ''"
  (click)="editBox()">
  <div class="card__header">
    <div class="card__header__indicator__wrapper" [class.with-risk]="box?.penalty_with_risk || box?.cost">
      <div class="is-smart-sprint" *ngIf="box?.smart_sprints.length"></div>
      <div class="card__header__indicator" [class.is-ex-exercise]="box?.is_ex_exercise">
        {{ cardIndex }}
      </div>
    </div>

    <div
      class="card__header__box-level">
      Уровень {{ boxLevel }}
    </div>
    <div class="card__header__kairos-bonus" *ngIf="kairosBonus?.box" [title]="'Кайрос-бонус: ' + kairosBonus.bonus">
      <img
        src="/assets/images/privilege_icons/kairos_bonus_icon.png"
        alt="Кайрос бонус">
    </div>
    <div class="card__header__privileges">
      <span class="privilege-icon" *ngFor="let privilege of activePrivilegeSettings">
        <img
          [src]="mainDomain + privilege.character.icon_url"
          class="card__header__privileges__image"
          [alt]="privilege.character.title"
          [title]="privilege.privilege.title">
      </span>
    </div>
  </div>
  <div class="card__body">
    <div class="card__image__wrapper">
      <div *ngIf="box.files && box.files.length > 0; else newCard">
        <div [ngSwitch]="box.cards_format" *ngIf="cardTemplate; else cardLoading">
          <img class="card__image" src="/assets/images/cards/preview_A7.png" *ngSwitchCase="'A7'" alt="A7">
          <img class="card__image" src="/assets/images/cards/preview_A6.png" *ngSwitchCase="'A6'" alt="A6">
          <img class="card__image" src="/assets/images/cards/preview_A5.png" *ngSwitchCase="'A5'" alt="A5">
          <img class="card__image" src="/assets/images/cards/preview_A3.png" *ngSwitchCase="'A3'" alt="1/6">
          <app-preview-img
            [cardsFormat]="box.cards_format"
            [box]="box"
            [boxLevels]="boxLevels"
            [cardTemplate]="cardTemplate"
            [lessonDate]="lessonDate"
            [character]="character">
          </app-preview-img>
        </div>
        <ng-template #cardLoading>
          <div class="card__loading">
            <div class="load">Загрузка..</div>
          </div>
        </ng-template>
      </div>
    </div>
    <ng-template #newCard>
      <div class="card__loading">
        <div class="new">Добавить настройки</div>
      </div>
    </ng-template>
  </div>
  <div class="card__footer">
    <div class="card__footer__options-count">{{ numberOfCards }} шт.</div>
    <!-- <div class="card__footer__count">{{ numberOfCards }}</div> -->
    <div class="card__footer__actions">
      <div *ngIf="box.smart_sprints.length" class="card__footer__actions__button icon-button box-online">
        online
      </div>
      <div
        class="card__footer__actions__button icon-button"
        (click)="printBoxCard()"
        *ngIf="box.generated && !box.smart_sprints.length"
        title="Напечатать">
        <app-svg-icon [src]="printIcon" class="icon"></app-svg-icon>
      </div>
      <ng-container *ngIf="groupRights.copy_other_lesson.is_access">
        <div
          class="card__footer__actions__button icon-button"
          (click)="copyBoxCard($event)"
          *ngIf="box.number_of_cards !== 0"
          title="Скопировать">
          <app-svg-icon [src]="duplicateIcon" class="icon"></app-svg-icon>
        </div>
      </ng-container>
      <ng-container *ngIf="groupRights.edit_other_lesson.is_access">
        <div class="card__footer__actions__button icon-button" (click)="deleteBoxCard()" title="Удалить">
          <app-svg-icon [src]="removeIcon" class="icon"></app-svg-icon>
        </div>
      </ng-container>
    </div>
  </div>
</div>
